import React, { useEffect, useRef } from 'react'

import biBannerImage from '../../assets/img/conSaldoAdm.svg'
import biBannerLogo from '../../assets/img/logoBiAzul.png'

const BiBanner = ({ packRecurrence, onClick, sendMetrics }) => {
  const bannerRef = useRef(null)

  useEffect(() => {
    const banner = bannerRef.current

    if (banner) {
      banner.classList.add('animate-jump')
      const timer = setTimeout(() => {
        banner.classList.remove('animate-jump')
      }, 3000)

      return () => clearTimeout(timer)
    }
  }, [])

  const handleBiBanner = () => {
    if (sendMetrics) {
      const metricsData = {
        metricType: 'Banner_Pago_BI',
        metricName: 'Banner_Pago_BI',
      }
      sendMetrics(metricsData)
    }

    onClick()
  }

  return (
    <div
      ref={bannerRef}
      className={`claro__container__biBanner ${
        packRecurrence ? 'recurrenceBanner' : ''
      } `}
      onClick={handleBiBanner}
    >
      <div className="claro__container__biBanner__icon">
        <img src={biBannerImage} alt="biBannerImage" />
      </div>
      <div className="claro__container__biBanner__text">
        <div className="claro__container__biBanner__text__title">
          Nuevo Método de Pago!!!
        </div>
        <div className="claro__container__biBanner__text__subtitle">
          Ahora puedes pagar con tu cuenta Monetaria y de Ahorro
        </div>
      </div>
      <div className="claro__container__biBanner__logo">
        <img src={biBannerLogo} alt="biBannerLogo" />
      </div>
    </div>
  )
}

export default BiBanner
